export class Paginator {
    lazy = true;
    paginator = true;
    rows = 10;
    totalRecords = 0;
    loading = false;
    rowsPerPageOptions = [5, 10, 25, 50];
    first = 0;
    currentPageReportTemplate= '{totalRecords} résultats';
}
